const aboutApi = [
    {
        id: 1,
        title: "Sign In",
        info : "Firstly you install Our App in your phone. It is free for everyone for all types of facility. You don't need to pay any type of money with anyone. If you want paid course then you go for it.", 
    },
    {
        id: 2,
        title: "Create Your Account",
        info : "The easiest and simple way to create account in Doubtnut app, We provude you. Via Mobile Number or Email ID both you create account in two which is you have that it use for creating account. Once create account then Explore your courses.",
    },
    {
        id: 3,
        title: "Choose Your Preference Courses",
        info : "After creating account you choose your class and courses for better performance and for giving you most appropriate response from Doubtnut Side. For Solving your doubt you need take photo of your question and then submit it for solution",
    },
];

const aboutApi2 = [
    {
        id: 1,
        title: "WhatsApp Chat and Video Call Support",
        info : "Doubtnut provide you to whatsapp chat facility in anytime time 24/7 facility available. If you want solve your question Via Video call then you go for video call because they also provide to Video Call facility for all user.", 
    },
    {
        id: 2,
        title: "Doubt & Mentoring Supporting",
        info : "Doubtnut All teacher perday taking live doubt solving class and mentoring class. In doubt solving class you ask your doubt and take solution perday. In mentoring class teachers are provide you approach to how you solve this question and later you able to solve that question.",
    },
    {
        id: 3,
        title: "Live Video Solution Of Your Question",
        info : "Doubtnut have your all doubt question video solution. They give you access to see all Video Solution and solve your question without taking teachers help. This facility makes Doubtnut famous because you see multiple times your doubt Solution video.",
    },
];

export {aboutApi2};
export default aboutApi;